export default "__VITE_ASSET__4cd7e587__"